import React from 'react'

const blogs = () => {
  return (
    <div>blogs</div>
  )
}

export default blogs